import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {SharedModule} from 'app/shared/shared.module';
import { BreadcrumbComponent } from './breadcrumb.component';
import { RouterModule } from '@angular/router';
import { GlobalState } from '../global.state';
import { BreadcrumbService } from './breadcrumb.service';

@NgModule({
    declarations: [
        BreadcrumbComponent
    ],
    imports: [
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        SharedModule,
        RouterModule
    ],
    exports: [
        BreadcrumbComponent
    ],
    providers :[
        GlobalState,
        BreadcrumbService
    ]
})
export class BreadcrumbModule {
}
